import "./style.scss";

export default function StickyContent({ children }) {
  return (
    <div className="sticky-content-wrapper">
      <div className="inner">{children}</div>
    </div>
  );
}
